export const DEBT_SCHEDULE_DRAWER_MODAL_ID = 'DEBT_SCHEDULE_DRAWER_MODAL_ID';

export const defaultValuesSimulatedDataForm = {
  debt_and_hedge_enabled: false,
  enable_hedge_breakage: false,
  cftt: false,
  notional: 100000000,
  fundingSpread: 500,
  normalVolAdjustment: 5,
  floorStrike: 1,
  dayCount: 360,
  hedgePercentage: '0.75',
  amortRate: 0,
};
